exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.ant-card[data-v-4640b3fe] {\n  margin-bottom: 0;\n}\nbutton.ant-btn.ant-btn-primary[data-v-4640b3fe] {\n  margin-bottom: 0;\n}\n.ant-select-dropdown-menu[data-v-4640b3fe] {\n  max-height: 80px;\n  overflow: auto;\n}\n", ""]);

// exports
